export enum AppEvents {
    StartProcessing = 'StartProcessing',
    EndProcessing = 'EndProcessing',
    StartLoader = 'StartLoader',
    EndLoader = 'EndLoader',
    SuccessfulCheckout = 'SuccessfulCheckout',
    ErrorCheckout = 'ErrorCheckout',
}
